import React from "react";
import Projects from "./projects/Projects";

// import components

const Portfolio = () => {
  return (
    <section id="portfolio" className="section bg-tertiary min-h-[1400px]">
      <div className="container mx-auto">
        <div className="flex flex-col items-center text-center">
          <h2 className="section-title before:content-portfolio relative before:absolute before:opacity-40 before:-top-[2rem] before:-left-3/4 before:hidden before:lg:block">
            Our latest work
          </h2>
          <p className="subtitle">
            We create powerful technology solutions for businesses worldwide.
            Our services include custom software, AI automation, mobile and web
            apps, DevOps, and digital services. Whether you're a startup or a
            large company, we help turn ideas into reality, making businesses
            more efficient, scalable, and successful.
          </p>
        </div>
        <Projects />
      </div>
    </section>
  );
};

export default Portfolio;
